import { render, staticRenderFns } from "./MainProjectMetaDataTab.vue?vue&type=template&id=644429a0&scoped=true&"
import script from "./MainProjectMetaDataTab.vue?vue&type=script&lang=ts&"
export * from "./MainProjectMetaDataTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644429a0",
  null
  
)

export default component.exports